import axios from "axios";
import config from "@/config/index"; // 路径配置
import enumObject from '@/utils/enum'
import { getLocalStorage } from "@/utils/auth";
import { isWeiXin } from '@/utils'
import { sortASCII, preDecode, deepClone } from "@/utils";
import md5 from 'js-md5';
import store from "../store";
// import { getLocalStorage } from "@/utils/auth";
import { Dialog } from "vant";
// 创建axios 实例
const service = axios.create({
    baseURL: config.baseURL, // api的base_url
    timeout: 30000 // 请求超时时间
});
const isCrossPlatform = enumObject.providerConfig[config.projectName].CrossPlatform;
// request 拦截器
service.interceptors.request.use(
    config => {
        config.headers.common["token"] = "f9e08257652deaa76de81c8225801482";
        // config.headers.common["x-token"] = "1cf18da3372245bd96ffac517411313c";
        // 这里可以自定义一些config 配置
        if (config.method === "post") {

            let TempData = config.data ? deepClone(config.data) : {}
            TempData.appkey = '1629974079425'
            TempData.time = getLocalStorage('dateDiff') ? new Date().getTime() + parseInt(getLocalStorage('dateDiff')) : new Date().getTime()
            const s = md5(config.url + `${JSON.stringify(sortASCII({ ...TempData }))}1d24480b729d412c9f6cb0117968baec`)
            config.url = config.url + `?${preDecode('c2lnbg==')}=${s}&appkey=${TempData.appkey}&time=${TempData.time}`
            console.log(config.url)

            // config.data = qs.stringify({
            //   ...config.data
            // })
        } else if (config.method === "get") {
            config.params = Object.assign({
                appkey: '1629974079425',
                time: getLocalStorage('dateDiff') ? new Date().getTime() + parseInt(getLocalStorage('dateDiff')) : new Date().getTime()
            }, config.params)
            const s = md5(config.url + `${JSON.stringify(sortASCII({ ...config.params }))}1d24480b729d412c9f6cb0117968baec`)
            config.url = config.url + `?${preDecode('c2lnbg==')}=${s}`
        }
        return config;
    },
    error => {
        //  这里处理一些请求出错的情况

        Promise.reject(error);
    }
);

// response 拦截器
service.interceptors.response.use(
    response => {
        const res = response.data;
        if (res.status !== 1001) {
            // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
            if (res.status === 50008 || res.status === 50012 || res.status === 50014) {
                if (!isCrossPlatform && isWeiXin()) {
                    location.reload(); // 为了重新实例化vue-router对象 避免bug
                } else {
                    Dialog.confirm({
                        title: "确定登出",
                        message: "你已被登出，可以取消继续留在该页面，或者重新登录",
                        confirmButtonText: "重新登录",
                        // confirmButtonColor: '#1989fa',
                        cancelButtonText: "取消"
                    })
                        .then(() => {
                            store.dispatch("FedLogOut").then(() => {
                                location.reload(); // 为了重新实例化vue-router对象 避免bug
                            });
                        })
                        .catch(() => {
                            // on cancel
                        });
                }
            }
        }
        return res;
        // 这里处理一些response 正常放回时的逻辑
    },
    error => {
        // 这里处理一些response 出错时的逻辑
        console.log({ message: error });
        return Promise.reject(error);
    }
);

export default service;